import { Observable } from "rxjs";
import { fetch, RequestResult, ContentType, createRequest } from "./fetchRequest";

export default function (url: string, data: any, contentType: ContentType = 'json'): Observable<RequestResult> {
    const request = createRequest(url, 'DELETE', data, contentType);
    return fetch(request);
}